import React, { Component, PropTypes } from 'react';
import { geti18n } from '../../../../../../../utils';
import {
  StyledOfferFinalWrapper,
  StyledFinalSummaryRow,
  StyledSigningTotal,
  StyledSigningTotalTitle
} from './styles';

/**
 * Bottom section of the Offer Summary containing the Monthly Payment and signing amount
 */
class SummaryFinal extends Component {
  static propTypes = {
    signingText: PropTypes.string,
    monthlyPaymentText: PropTypes.string,
    monthlyAmount: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]).isRequired,
    signingAmount: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]).isRequired
  };
  static defaultProps = {
    signingText: geti18n('offerPanel.summaryPanel.signingTotalText'),
    monthlyPaymentText: geti18n('offerPanel.summaryPanel.monthlyPaymentText')
  };
  render() {
    const { signingText, monthlyPaymentText, monthlyAmount, signingAmount } = this.props;
    return (
      <StyledOfferFinalWrapper className="offer-final-wrapper">
        <StyledFinalSummaryRow className="signing-total-wrapper summary-row summary-font">
          <StyledSigningTotalTitle className="signing-total-title">{signingText}</StyledSigningTotalTitle>
          <StyledSigningTotal className="signing-total">{signingAmount}</StyledSigningTotal>
        </StyledFinalSummaryRow>
        <div className="monthly-payment-wrapper">
          <span className="monthly-payment-title heading-first">{monthlyPaymentText}</span>
          <span className="monthly-payment heading-first">{monthlyAmount}</span>
        </div>
      </StyledOfferFinalWrapper>
    );
  }
}

export default SummaryFinal;



/** WEBPACK FOOTER **
 ** ./src/pages/TrimView/BestOfferList/BestOfferCard/components/OfferSummary/SummaryFinal/index.js
 **/